import Entity from "./Entity";
import IMei from "./IMei";

export interface DasDelivery {
	createdAt: Date;
	status: DasDeliveryStatus;
}

export enum DasDeliveryStatus {
	Pending = 0,
	Sent = 1,
	Delivered = 2,
	Read = 3,
	LinkOpened = 4,
	Failed = 5,
	Cancelled = 6
}

export default interface IDas extends Entity {
	period?: string;
	calculated?: boolean;
	inss?: boolean;
	value?: number;
	fine?: number;
	interest?: number;
	total?: number;
	periodDate?: Date;
	dueDate?: Date;
	bankBilletDueDate?: Date;
	receptionDate?: Date;
	status?: DasStatus;
	documentNumber?: string;
	barCode?: string;
	link?: string;
	items?: any[];
	historic?: any[];
	mei?: IMei;
	deliveries?: DasDelivery[];
}

export enum DasStatus {
	pending = 0,
	paid = 1,
	notOpting = 2,
	due = 3,
	activeDebt = 4,
	inInstallments = 5
}
